module.exports = __webpack_public_path__ + "img/qrec_scheme-18.7b54461f.png";